import { formatDate } from "@/utils/date-time-utility";
import {
  NOTE_PREVIEW_PDF_FILE_DATE_FORMAT,
  NOTE_PREVIEW_PDF_FILE_EXTENSION,
  NOTE_PREVIEW_PDF_FILE_NAME,
  NOTE_PREVIEW_PDF_FILE_SEPARATOR,
  NOTE_PREVIEW_UNSAFE_FILE_CHARS,
} from "./note-preview-constant";
import { EncounterSummaryReport } from "./note-preview-types";
import { templateTitle } from "./note-preview-utils";

const nonEmpty = (parts: (string | null | undefined)[]): string[] =>
  parts.filter((part): part is string => !!part?.trim());

/** Saves a generated PDF through a temporary anchor so the browser honours the file name. */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
};

/** `<Last>_<First>_<Template>_<DOS>.pdf`, falling back to the generic name when the parts are missing. */
export const buildPdfFileName = (
  report: EncounterSummaryReport | undefined
): string => {
  const parts = nonEmpty([
    report?.patientLastName,
    report?.patientFirstName,
    templateTitle(report),
    report?.appointmentDate
      ? formatDate(
          report.appointmentDate,
          undefined,
          NOTE_PREVIEW_PDF_FILE_DATE_FORMAT
        )
      : undefined,
  ]).map((part) =>
    part
      .trim()
      .replace(NOTE_PREVIEW_UNSAFE_FILE_CHARS, NOTE_PREVIEW_PDF_FILE_SEPARATOR)
  );
  return parts.length
    ? `${parts.join(NOTE_PREVIEW_PDF_FILE_SEPARATOR)}${NOTE_PREVIEW_PDF_FILE_EXTENSION}`
    : NOTE_PREVIEW_PDF_FILE_NAME;
};
